import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertBasic from "../alerts/AlertBasic";

class QuestionStatus extends Component {
    state = { questionStatusesList: [] };

    getQuestionStatus = async () => {
        const { fetchURL, defaultValue } = this.props;
        try {
            const response = await fetch(`${fetchURL}/question-statuses`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    if (fetchedData.status === true) {
                        const questionStatList = fetchedData.questionStatList;
                        if (defaultValue === "all") {
                            questionStatList.unshift({
                                key: 0,
                                value: "all",
                                text: "Wszystkie",
                            });
                        }

                        this.setState({ questionStatusesList: questionStatList });
                    } else if (fetchedData.status === false) {
                        this.setState({ alert: { variant: "danger", message: fetchedData.message } });
                    }
                });
            } else {
                this.setState({ alert: { variant: "danger", message: response.status } });
            }
        } catch (err) {
            this.setState({ loading: false, alert: { variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." } });
            setTimeout(this.getQuestionStatus(), 4000);
        }
    };

    componentDidMount() {
        this.getQuestionStatus();
    }

    render() {
        const { questionStatusesList, alert } = this.state;
        const { defaultValue, onQuestionStatSelected, req } = this.props;
        return (
            <Fragment>
                {alert && <AlertBasic variant={alert.variant} mssg={alert.message} onCloseAlert={() => this.setState({ alert: "" })} fading={alert.fading} />}

                <Form.Group>
                    <Form.Label>Status pytania {req && <span className="required">*</span>}</Form.Label>

                    <Dropdown
                        value={defaultValue}
                        id="questionStatDropdown"
                        className={req ? "form-dropdown mb-3 req" : "form-dropdown mb-3"}
                        placeholder="Wszystkie"
                        fluid
                        selection
                        options={questionStatusesList}
                        onChange={(event, { value }) => {
                            onQuestionStatSelected(event, value);
                        }}
                    />
                </Form.Group>
            </Fragment>
        );
    }
}

export default QuestionStatus;
